export const PIN_SIZE = 48
export const PIN_HEIGHT = 72
